import { ILayout } from 'src/interfaces';

import {
  ScheduleComponentLayoutWrapper,
  StepContentContainer,
  StepContentWrapper,
  StyledFilterContainer,
} from '../../ScheduleComponentPage.styled';
import { ScheduleComponentLayout } from '../scheduleComponentLayout';
import { ScheduleComponentPageSidebar } from '../scheduleComponentPageSidebar';

export const ScheduleComponentContent = (props: {
  layout: ILayout | undefined;
}) => {
  return (
    <StepContentWrapper>
      <StepContentContainer container spacing={2}>
        <StyledFilterContainer item xs={12} md={3}>
          {props.layout && <ScheduleComponentPageSidebar />}
        </StyledFilterContainer>

        <ScheduleComponentLayoutWrapper item xs={12} md={9}>
          {props.layout && <ScheduleComponentLayout />}
        </ScheduleComponentLayoutWrapper>
      </StepContentContainer>
    </StepContentWrapper>
  );
};
